import { TravelClubGrade } from '@flight-workspace/common-client/src/types/travelUser';
import isEmpty from 'lodash/isEmpty';
import { IIsTravelClub, IBookingPartnersHashMap } from './types';

const reservedBookingPartnersHashMap: IBookingPartnersHashMap = {
  KRT006: 'KRT',
  NIT015: '내일투어',
  YEL009: '노랑풍선',
  HDT028: '더현대트래블',
  LTT017: '롯데관광',
  JTB016: '롯데제이티비',
  LOT011: '롯데카드여행',
  MRT023: '마이리얼트립',
  MOT007: '모두투어',
  ONT003: '온라인투어',
  WHY002: '와이페이모어',
  WEB001: '웹투어',
  INT005: '인터파크투어',
  JAU020: '자유투어',
  JJD026: '제주도닷컴',
  VGT027: '참좋은여행',
  TOT024: '투어2000',
  TOV025: '투어비스',
  TRP016: '트리플',
  CTR013: '트립닷컴',
  HAT004: '하나투어',
  HDP010: '현대카드 PRIVIA',
};

export const isTravelClub = ({
  grade,
  otaId,
  bookingPartnersHashMap,
}: IIsTravelClub) => {
  const bookingPartners = isEmpty(bookingPartnersHashMap)
    ? reservedBookingPartnersHashMap
    : bookingPartnersHashMap;
  return !!(
    [TravelClubGrade.SMART, TravelClubGrade.GOLD].includes(grade) &&
    bookingPartners[otaId]
  );
};

export default { isTravelClub };
